import { api } from "../helpers";

const prefix = "/points";

export const getPointsAdditionalList = (param, token) => {
	return api(`${prefix}/additional`, "GET", undefined, param, token);
};

export const getPointsAdditional = (param, token) => {
	const { id, ...rest } = param;

	return api(`${prefix}/additional/${id}`, "GET", undefined, rest, token);
};

export const postPointsAdditional = (payload, token) => {
	return api(`${prefix}/additional`, "POST", payload, undefined, token);
};

export const deletePointsAdditionalById = (payload, token) => {
	const { id, ...rest } = payload;

	return api(`${prefix}/additional/${id}`, "DELETE", rest, undefined, token);
};

export const updatePointsAdditional = (payload, token) => {
	return api(`${prefix}/additional`, "PUT", payload, undefined, token);
};
